import * as form from '../form';

export const legalAssociationsInternationalAndDomesticTerrorismAssociation = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        When: form.daterange(xitem.When),
        WhyStop: form.textarea(xitem.WhyStop),
        WhyStill: form.textarea(xitem.WhyStill),
        What: form.textarea(xitem.What),
      },
    };
  });
  return {
    HasInternationalAndDomesticTerrorismAssociation: form.branch(data.HasInternationalAndDomesticTerrorismAssociation),
    List: form.collection(items, (data.List || {}).branch),
  };
};
